<template>
  <div>
    <v-dialog v-model="addDialog" max-width="250px">
      <v-card class="whiteScroll">
        <v-card-title>
          <v-form ref="addForm" @submit.prevent="addFriend()">
            <v-text-field
              v-model="addInput"
              autocomplete="off"
              label="Username"
              :placeholder="user.username + '#' + user.discriminator"
              style="width:200px!important"
              class="mb-1"
              :error-messages="addInputErrors"
              :loading="addInputLoading"
              :disabled="addInputLoading"
            ></v-text-field>
            <v-btn
              :disabled="addInputLoading"
              block
              class="mb-2"
              color="primary"
              @click="addFriend()"
              >Add</v-btn
            >
          </v-form>
        </v-card-title>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mainDialog" max-width="52%">
      <v-card class="whiteScroll">
        <v-card-title>
          <v-text-field
            v-model="search"
            autocomplete="off"
            append-icon="mdi-magnify"
            placeholder="Search.."
            clearable="true"
            single-line
            hide-details
            :disabled="tableLoading"
          ></v-text-field>
          <v-btn
            fab
            small
            color="black"
            class="ml-6 mt-2"
            @click="addDialog = true"
            :disabled="tableLoading"
          >
            <v-icon color="white">mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table
          id="dataTable"
          disable-sort
          fixed-header
          height="191px"
          :loading="tableLoading"
          :headers="headers"
          :items="friends"
          :search="search"
        >
          <template v-slot:no-results>
            <div class="clickable" @click="addDialog = true">
              <h4 colspan="4">Not found. Click to add them!</h4>
            </div>
          </template>
          <template v-slot:no-data>
            <div class="clickable" @click="addDialog = true">
              <h4 colspan="4">
                You've not added any friends. Click to add one!
              </h4>
            </div>
          </template>
          <template v-slot:item.avatar="{ item }">
            <v-avatar size="32">
              <v-img
                v-if="item.avatar"
                avatar
                :src="
                  `https://cdn.discordapp.com/avatars/${item.id}/${item.avatar}.webp?size=256`
                "
                :alt="item.name"
              ></v-img>
              <v-img
                v-else
                avatar
                :src="require('@/assets/defaultpfp.png')"
                :alt="item.name"
              ></v-img>
            </v-avatar>
          </template>
          <template v-slot:item.discriminator="{ item }"
            >#{{ item.discriminator }}</template
          >
          <template v-slot:item.remove="{ item }">
            <v-btn icon @click="remove(item)" class="pa-0 ma-0">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn
              v-if="host"
              :disabled="!(viewerLength < viewerCap())"
              icon
              @click="invite(item)"
              class="pa-0 ma-0"
            >
              <v-icon>mdi-account-plus</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
#dataTable > .v-data-table__wrapper {
  overflow-x: auto !important;
}
</style>

<script>
export default {
  data: () => ({
    mainDialog: false,
    addDialog: false,
    search: "",
    addInput: "",
    addInputLoading: false,
    addInputErrors: [],
    tableLoading: false,
    headers: [
      { text: "Avatar", value: "avatar", align: "center", filterable: false },
      { text: "Username", value: "username", align: "center" },
      { text: "Discriminator", value: "discriminator", align: "center" },
      { text: "Action", value: "remove", align: "center" }
    ],
    friends: [],
    host: false,
    viewerLength: 0,
    roomName: "",
    roomCover: ""
  }),
  watch: {
    mainDialog: function(newV) {
      if (newV) {
        this.tableLoading = true;
        this.$socket.emit("get friends", this.user.id, friends => {
          this.tableLoading = false;
          this.friends = friends;
        });
      }
    },
    addInput: function() {
      this.addInputErrors = [];
    },
    addDialog: function() {
      this.addInput = "";
      this.addInputErrors = [];
    }
  },
  computed: {
    user() {
      return this.$store.state.user || { username: "" };
    }
  },
  methods: {
    open(host, roomName, roomCover, viewerLength) {
      this.host = host;
      this.roomName = roomName;
      this.roomCover = roomCover;
      this.viewerLength = viewerLength;
      this.mainDialog = true;
    },
    remove(item) {
      this.$root
        .$confirm(
          "Warning",
          "Are you sure you want to remove " +
            item.username +
            "#" +
            item.discriminator +
            "?",
          { color: "red darken-2" }
        )
        .then(sure => {
          if (sure) {
            this.tableLoading = true;
            // this.friends = [];
            this.$socket.emit(
              "remove friend and return list",
              this.user.id,
              item.id,
              friends => {
                this.tableLoading = false;
                if (friends) {
                  this.friends = friends;
                } else {
                  this.$root.$alert("Error", "Failed to remove friend.", {
                    color: "red"
                  });
                }
              }
            );
          }
        });
    },
    addFriend() {
      let valid =
        this.addInput.slice(this.addInput.length - 5, -4) == "#" &&
        new RegExp(/[0-9]{4}/i).test(this.addInput) &&
        this.addInput.length < 40;
      if (this.addInput && valid) {
        if (
          this.user.username + "#" + this.user.discriminator !==
          this.addInput
        ) {
          this.addInputLoading = true;
          this.$socket.emit(
            "lookup user and return friends",
            this.user.id,
            this.addInput,
            outcome => {
              this.addInputLoading = false;
              if (outcome.response == "success") {
                this.friends = outcome.friends;
                this.addDialog = false;
              } else if (outcome.response == "member not found") {
                this.addInputErrors = ["User hasn't used Trast"];
              } else if (outcome.response == "already a friend") {
                this.addInputErrors = ["That friend is already added"];
              } else if (outcome.response == "error") {
                this.$root.$alert("Error", "Failed to add friend.", {
                  color: "red"
                });
              }
            }
          );
        } else {
          this.addInputErrors = ["You can't befriend yourself"];
        }
      } else {
        this.addInputErrors = ["Invalid username"];
      }
    },
    viewerCap() {
      if (this.user.donatorTier == 2) {
        return 30;
      } else if (this.user.donatorTier == 1) {
        return 15;
      } else {
        return Infinity;
      }
    },
    invite(user) {
      let object = {
        user: this.user,
        roomName: this.roomName,
        roomCover: this.roomCover,
        invited: user
      };
      this.$socket.emit("invite user", object, result => {
        if (result) {
          this.$root.$alert("Notice", "Your friend was successfully invited.");
        } else {
          this.$root.$alert(
            "Alert",
            "You have already invited that friend recently, try again later.",
            { color: "red" }
          );
        }
      });
    }
  }
};
</script>
